/**
 * esquery
 *  ## 1.ES를 이용해서 쿼리 API를 정의한다 .
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { EsCallRecord } from '../model/esCallRecord';
import { EsFailure } from '../model/esFailure';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EsCallRecordService {

    protected basePath = 'https://bstore-dev-nlb-to-backends-03c7de26a0c53e22.elb.ap-northeast-2.amazonaws.com:9980/esquery/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 콜라비 녹취파일 저장정보 조회
     * 
     * @param gte 
     * @param lte 
     * @param tel_no 
     * @param emp_name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public callRecordsGet(gte?: string, lte?: string, tel_no?: string, emp_name?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<EsCallRecord>>;
    public callRecordsGet(gte?: string, lte?: string, tel_no?: string, emp_name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<EsCallRecord>>>;
    public callRecordsGet(gte?: string, lte?: string, tel_no?: string, emp_name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<EsCallRecord>>>;
    public callRecordsGet(gte?: string, lte?: string, tel_no?: string, emp_name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (gte !== undefined && gte !== null) {
            queryParameters = queryParameters.set('gte', <any>gte);
        }
        if (lte !== undefined && lte !== null) {
            queryParameters = queryParameters.set('lte', <any>lte);
        }
        if (tel_no !== undefined && tel_no !== null) {
            queryParameters = queryParameters.set('tel_no', <any>tel_no);
        }
        if (emp_name !== undefined && emp_name !== null) {
            queryParameters = queryParameters.set('emp_name', <any>emp_name);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        return this.httpClient.get<Array<EsCallRecord>>(`${this.basePath}/call/records`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
